// import router from '../router'
import pointService from '../service/point';
import Vue from 'vue';
// import { Message } from 'element-ui'

const state = {
    status: {
        loading: true,
        creating: true
    },
    points: [],
    point: '',
    pointLoading: false,
};

const actions = {
    getVibrationAnalyzeReports({ commit }, pointId) {
        return pointService.getVibrationAnalyzeReports(pointId).then((reports) => {
            commit('setVibrationAnalyzeReports', { pointId, reports });
            return;
        });
    },
    deletePeriodic({ commit }, pointId) {
        return pointService.deletePeriodic(pointId).then(() => {
            commit('deletePeriodic', pointId);
            return;
        });
    },
    updatePeriodic({ commit }, { pointId, periodic }) {
        return pointService.updatePeriodic(pointId, periodic).then(() => {
            commit('updatePeriodic', { pointId, periodic });
            return;
        });
    },
    updateChannelGroups({ commit }, { id, channelGroups }) {
        return pointService.updateChannelGroups(id, channelGroups).then(() => {
            commit('updateChannelGroups', { id, channelGroups });
            return;
        });
    },
    updateTrigger({ commit }, { pointId, trigger }) {
        return pointService.updateTrigger(pointId, trigger).then(() => {
            commit('updateTrigger', { pointId, trigger });
            return;
        });
    },
    deleteTrigger({ commit }, pointId) {
        return pointService.deleteTrigger(pointId).then(() => {
            commit('deleteTrigger', pointId);
            return;
        });
    },
    deleteDevice({ commit ,dispatch}, pointId) {
        return pointService.deleteDevice(pointId).then(() => {
            commit('deleteDevice', pointId);
            dispatch('getPoints', pointId);
            return;
        });
    },
    updateDevice({ commit ,dispatch}, { pointId, macAddress, gateway,channelGroups }) {
        return pointService.updateDevice(pointId, macAddress, gateway).then(() => {
            commit('updateDevice', { pointId, macAddress, gateway,channelGroups });
            dispatch('getPoints', pointId);
            return;
        });
    },
    deleteProfile({ commit ,dispatch}, pointId) {
        return pointService.deleteProfile(pointId).then(() => {
            commit('deleteProfile', pointId);
            
            return;
        });
    },
    updateProfile({ commit }, { pointId, profile }) {
        return pointService.updateProfile(pointId, profile).then(() => {
            commit('updateProfile', { pointId, profile });
            return;
        });
    },
    getPoint({ commit }, pointId) {
        commit('setPointLoading', true);
        return pointService.getPoint(pointId).then(p => {
            commit('setPoint', p);
        }).finally(() => commit('setPointLoading', false));
    },
    getPoints({ commit }, selectedPoints) {
        commit('setLoading', true);
        return pointService.findPoints(selectedPoints).then(points => {
            commit('setPoints', points);
        });
    },
};
const mutations = {
    setVibrationAnalyzeReports(state, { pointId, reports }) {
        const index = state.points.findIndex(x => x._id == pointId);
        if (index != -1) {
            Vue.set(state.points, index, {
                ...state.points[index]
                , vibrationAnalyzeReports: reports
            });
        }
    },
    deletePeriodic(state, pointId) {
        const index = state.points.findIndex(x => x._id == pointId);
        if (index != -1) {
            Vue.set(state.points, index, {
                ...state.points[index]
                , periodic: undefined
            });
        }
    },
    updateChannelGroups(state, { id, channelGroups }) {
        const index = state.points.findIndex(x => x._id == id);
        if (index != -1) {
            state.points[index] = {...state.points[index], device: {...state.points[index].device,channelGroups :channelGroups}}
        }
        if(state.point){
            state.point = {...state.point, device: {...state.point.device,channelGroups :channelGroups}}
        }
    },
    deleteTrigger(state, pointId) {
        const index = state.points.findIndex(x => x._id == pointId);
        if (index != -1) {
            Vue.set(state.points, index, {
                ...state.points[index]
                , trigger: undefined
            });
        }
    },
    updatePeriodic(state, { pointId, periodic }) {
        const index = state.points.findIndex(x => x._id == pointId);
        if (index != -1) {
            Vue.set(state.points, index, {
                ...state.points[index]
                , periodic
            });
        }
    },
    updateTrigger(state, { pointId, trigger }) {
        const index = state.points.findIndex(x => x._id == pointId);
        if (index != -1) {
            Vue.set(state.points, index, {
                ...state.points[index]
                , trigger
            });
        }
    },
    deleteProfile(state, pointId) {
        const index = state.points.findIndex(x => x._id == pointId);
        if (index != -1) {
            Vue.set(state.points, index, {
                ...state.points[index]
                , profile: undefined
            });
        }
    },
    updateProfile(state, { pointId, profile }) {
        const index = state.points.findIndex(x => x._id == pointId);
        if (index != -1) {
            Vue.set(state.points, index, {
                ...state.points[index]
                , profile
            });
        }
    },
    deleteDevice(state, pointId) {
        const index = state.points.findIndex(x => x._id == pointId);
        if (index != -1) {
            Vue.set(state.points, index, {
                ...state.points[index]
                , device: undefined
            });
        }
    },
    updateDevice(state, { pointId, macAddress, gateway,channelGroups }) {
        const index = state.points.findIndex(x => x._id == pointId);
        if (index != -1) {
            Vue.set(state.points, index, {
                ...state.points[index]
                , device: {
                    macAddress,
                    gateway,
                    channelGroups:channelGroups
                }
            });
        }
    },
    setLoading(state, loading) {
        state.status.loading = loading;
    },
    setPointLoading(state, loading) {
        state.pointLoading = loading;
    },
    setPoint(state, point) {
        state.point = point;
    },
    setPoints(state, points) {
        state.points = points;
        state.status.loading = false;
    },
};
export default {
    namespaced: true,
    state,
    actions,
    mutations
};
